import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const PngIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="77"
    height="76"
    viewBox="0 0 77 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="png-icon-mask"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="77"
      height="76"
    >
      <rect width="77" height="76" rx="4" fill="#D9D9D9" />
    </mask>
    <g mask="url(#png-icon-mask)">
      <rect
        x="-10"
        y="-6"
        width="97"
        height="87"
        className="fill-[#FFE6D3] dark:fill-[#442C1D]"
      />
      <path
        d="M42.2532 18H27.2269C25.7801 18 24.6006 19.1795 24.6006 20.6341V55.6328C24.6006 57.0874 25.78 58.259 27.2347 58.2669H53.6154C55.0701 58.2669 56.2417 57.0874 56.2495 55.6328L56.1709 29.6374L42.2532 18Z"
        fill="#F99746"
      />
      <path
        d="M42.2546 18L42.2153 29.3622C42.2153 29.3622 42.2546 29.6374 42.4905 29.6374H56.1723L42.2546 18Z"
        fill="#ED7D2B"
      />
      <path
        d="M22.0694 37.3982H48.6152C49.2049 37.3982 49.6846 37.8778 49.6846 38.4676V50.3251C49.6846 50.9149 49.2049 51.3945 48.6152 51.3945H22.0694C21.4796 51.3945 21 50.9149 21 50.3251V38.4676C21 37.8778 21.4796 37.3982 22.0694 37.3982Z"
        fill="#ED7D2B"
      />
      <g className="fill-white dark:fill-[#292C4B]">
        <path d="M28.7855 45.5965H27.05V44.3293H28.7855C29.022 44.3293 29.2138 44.2904 29.3608 44.2124C29.5079 44.1345 29.6149 44.0269 29.6821 43.8898C29.7524 43.7495 29.7875 43.5921 29.7875 43.4175C29.7875 43.2305 29.7524 43.0574 29.6821 42.8985C29.6149 42.7395 29.5079 42.6117 29.3608 42.515C29.2138 42.4153 29.022 42.3654 28.7855 42.3654H27.6828V47.9065H26V41.0982H28.7855C29.3449 41.0982 29.8259 41.198 30.2286 41.3975C30.6345 41.597 30.9462 41.8713 31.1635 42.2204C31.3809 42.5665 31.4895 42.9624 31.4895 43.4081C31.4895 43.8477 31.3809 44.2311 31.1635 44.5585C30.9462 44.8858 30.6345 45.1414 30.2286 45.3253C29.8259 45.5061 29.3449 45.5965 28.7855 45.5965Z" />
        <path d="M38.2256 41.0982V47.9065H36.5476L34.0785 43.67V47.9065H32.3957V41.0982H34.0785L36.5476 45.3347V41.0982H38.2256Z" />
        <path d="M45 44.2685V47.0648C44.8817 47.1926 44.6996 47.3298 44.4534 47.4763C44.2105 47.6197 43.9037 47.7428 43.5329 47.8457C43.1622 47.9486 42.7259 48 42.2241 48C41.7606 48 41.3403 47.9283 40.9632 47.7849C40.586 47.6384 40.2616 47.4248 39.9899 47.1443C39.7214 46.8606 39.5137 46.5146 39.3666 46.1062C39.2228 45.6947 39.1509 45.224 39.1509 44.6941V44.3153C39.1509 43.7853 39.2244 43.3146 39.3714 42.9031C39.5185 42.4916 39.7246 42.1456 39.9899 41.8651C40.2584 41.5814 40.5732 41.3663 40.9344 41.2198C41.2988 41.0733 41.6983 41 42.133 41C42.7754 41 43.298 41.0998 43.7007 41.2993C44.1035 41.4957 44.4087 41.7684 44.6165 42.1176C44.8242 42.4636 44.9505 42.8642 44.9952 43.3193H43.3795C43.3475 43.0949 43.2868 42.9047 43.1973 42.7488C43.111 42.5898 42.9864 42.4698 42.8234 42.3888C42.6604 42.3046 42.4494 42.2625 42.1905 42.2625C41.9891 42.2625 41.8054 42.3046 41.6392 42.3888C41.4762 42.4729 41.3371 42.6008 41.2221 42.7722C41.107 42.9405 41.0175 43.1525 40.9536 43.4081C40.8928 43.6638 40.8625 43.963 40.8625 44.3059V44.6941C40.8625 45.0338 40.8912 45.3316 40.9488 45.5872C41.0095 45.8428 41.099 46.0563 41.2173 46.2278C41.3387 46.3961 41.4921 46.5239 41.6775 46.6112C41.8661 46.6954 42.0882 46.7375 42.3439 46.7375C42.5229 46.7375 42.6763 46.7234 42.8042 46.6954C42.932 46.6642 43.0375 46.6268 43.1206 46.5832C43.2069 46.5364 43.2724 46.4928 43.3172 46.4522V45.3955H42.1474V44.2685H45Z" />
      </g>
    </g>
  </svg>
);
